import React, { useEffect, useState, useMemo } from "react";
import styled from "@emotion/styled";

import { BREAKPOINTS } from "../../components/configs/consts";
import close from "../../assets/close-white.png";

const StartUpMessagePopUp = ({ message, handleClose, config }) => {
  const [currentScreen, setCurrentScreen] = useState({});
  const [screenIndex, setScreenIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  const source = useMemo(
    () => ({ __html: currentScreen.DescriptionRich__c || "<p></p>" }),
    [currentScreen.DescriptionRich__c]
  );

  const nextScreen = (isCloseButton = false) => {
    if (isCloseButton) {
      handleClose({}, message, "Close Button Portal");
    } else {
      if (
        message.RedirectLink__c &&
        message?.RedirectAppScreen__c === "Webview"
      ) {
        handleClose(
          {
            screen: "Webview",
            params: {
              title: message.ButtonText__c,
              url: message.RedirectLink__c,
            },
          },
          message,
          `Button Pressed Portal: ${screenIndex + 1}/1`
        );
      } else if (message.RedirectAppScreen__c) {
        handleClose(
          { screen: "AppScreen" },
          message,
          `Button Pressed Portal: ${screenIndex + 1}/1`
        );
      }
    }
  };

  useEffect(() => {
    setScreenIndex(0);
    if (message?.StartUpMessageItems__r?.records?.length) {
      setCurrentScreen(message.StartUpMessageItems__r.records[0]);
    }
    setLoading(false);
  }, [message]);

  return (
    <StyledContainer config={config}>
      <div className="popup">
        <button className="close-button" onClick={() => nextScreen(true)}>
          <img className="close-icon" src={close} alt="close icon" />
        </button>

        {currentScreen.ImageUrl__c && (
          <img
            className="popup-image"
            src={currentScreen.ImageUrl__c}
            alt="popup"
          />
        )}

        {(source || message.ButtonText__c) && (
          <div className="txt-container">
            {source && (
              <div className="popup-text" dangerouslySetInnerHTML={source} />
            )}

            {message.ButtonText__c && (
              <div className="popup-actions">
                <button className="action-button" onClick={() => nextScreen()}>
                  {message.ButtonText__c}
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </StyledContainer>
  );
};

export default StartUpMessagePopUp;

const StyledContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.64);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99998;

  .popup {
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: ${(props) => props.config.colors.WHITE.W};
    box-shadow: 0px 4px 23.1px 2px rgba(0, 0, 0, 0.23);
    width: 100%;
    max-width: 674px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 12.8px;
    z-index: 99999;

    @media (max-width: ${BREAKPOINTS.PHONE_BIGGER}px) {
      max-width: 90%;
    }
  }

  .close-button {
    position: absolute;
    top: 16px;
    right: 16px;
    background: ${(props) => props.config.colors.BRAND.CRUZEIRO};
    border: none;
    border-radius: 8px;
    padding: 8px;
    cursor: pointer;

    .close-icon {
      width: 16px;
      height: 16px;
    }
  }

  .popup-image {
    width: 100%;
    height: 208px;
    object-fit: cover;
    border-top-left-radius: 12.8px;
    border-top-right-radius: 12.8px;

    @media (max-width: ${BREAKPOINTS.PHONE_BIGGER}px) {
      height: 168px;
    }
  }

  .popup-text {
    padding: 16px 24px 24px 24px;
    font-family: Outfit !important;
    text-align: left;
  }

  .popup-actions {
    display: flex;
    margin: auto;
    width: 60%;
    padding: 16px 24px;

    @media (max-width: ${BREAKPOINTS.PHONE_BIGGER}px) {
      width: 100%;
    }
  }

  .action-button {
    width: 100%;
    background-color: ${(props) => props?.config?.colors?.BRAND?.GOLD};
    color: ${(props) => props?.config?.colors?.BRAND?.DARK};
    border: none;
    border-radius: 8px;
    padding: 12px;
    font-family: Outfit;
    font-size: 14px;
    font-weight: 800;
    text-transform: uppercase;
    cursor: pointer;
  }
`;
